import { useEffect, useMemo, useState } from "react";
import { useApiClient } from "@/context/ApiContext";
import { getMySiteClients, MySiteClient } from "@/services/mysite/MySiteHome";
import { ClientOption } from "@/types/staffing/serviceRequest";

export function useServiceRequestClients(loginName: string, userLoading: boolean) {
  const api = useApiClient();
  const [data, setData] = useState<MySiteClient[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (userLoading || !loginName) return;
    let cancelled = false;
    setLoading(true);
    getMySiteClients(loginName, api)
      .then((response) => {
        if (!cancelled) setData(response.data ?? []);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
        if (!cancelled) setData([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [loginName, userLoading, api]);

  const clients: ClientOption[] = useMemo(
    () =>
      data.map((c) => ({
        id: c.id,
        name: c.name,
        encryptedId: c.encryptedId ?? null,
      })),
    [data],
  );

  return { clients, loadingClients: loading };
}
